import {DeviceParamLirisV2} from './type-v2/device-param-liris-v2';
import {DeviceParamOptV5} from './type-v5/device-param-opt-v5';
import {DeviceParamExtV5} from './type-v5/device-param-ext-v5';
import {DeviceParamLirisV3} from './type-v3/device-param-liris-v3';
import {DeviceParamInclinoV2} from './type-v2/device-param-inclino-v2';
import {DeviceParamGatewayV3} from './type-gateway-v3/device-param-gateway-v3';
import {DeviceParamDauV5} from './type-v5/device-param-dau-v5';
import {DeviceParamWavesoft} from './type-wavesoft/device-param-wavesoft';
import {DeviceParamLiris420} from './type-v3/device-param-liris-420';
import {DeviceTypes} from '../../enum/devicetypes.enum';

export class Device {


  public level: number;
  public device_type: number;
  public uid: string;
  public uid_erp: string;
  public parent: number;
  public channel: number;
  public unit: number;
  public length: number;
  public params: any;
  public active: boolean = true;
  public children: any[];
  public project_device_location?: any;
  public project_device_assignement?: any;

  constructor() {

  }

  public setDevice(data: any) {
    this.level = data.level.id;
    this.device_type = data.device_type ? data.device_type.id : null;
    this.uid = data.uid;
    this.uid_erp = data.uid_erp ? data.uid_erp : null;
    this.parent = data.parent ? data.parent.id : null;
    this.channel = data.channel;
    this.unit = data.unit ? data.unit.id : null;
    this.length = data.length;
    this.active = data.active;
    this.children = data.children;
    this.setDeviceParams(data);

  }

  public setDeviceParams(data: any) {
    let type = data.device_type.id;
    // liris v2
    if (type === DeviceTypes.LirisV2) {
      this.params = new DeviceParamLirisV2();
      this.params.paramA = data.params.paramA;
      this.params.paramB = data.params.paramB;
      this.params.paramC = data.params.paramC;
      this.params.trigger = data.params.trigger;
    }
    //optic v5
    if (type === DeviceTypes.OpticV5) {
      this.params = new DeviceParamOptV5();
      this.params.paramA = data.params.paramA;
      this.params.paramB = data.params.paramB;
      this.params.paramC = data.params.paramC;
      this.params.wp = data.params.wp;
      this.params.type = data.params.type;
    }
    //ext v5
    if (type === DeviceTypes.ExtV5) {
      this.params = new DeviceParamExtV5();
      this.params.paramA = data.params.paramA;
      this.params.paramB = data.params.paramB;
      this.params.paramC = data.params.paramC;
      this.params.paramD = data.params.paramD;
      this.params.paramE = data.params.paramE;
    }
    // inclino v2
    if (type === DeviceTypes.InclinoV2 || type === DeviceTypes.InclinobiaxisV2) {
      this.params = new DeviceParamInclinoV2();
      this.params.trigger = data.params.trigger;
    }
    // liris v3 CO
    // liris v3 INCLINO
    // liris v3 EXTENSO
    let v3Types: number[] = [DeviceTypes.LirisV3, DeviceTypes.InclinoV3, DeviceTypes.ExtV3, DeviceTypes.Exteg, DeviceTypes.Expe];
    if (v3Types.includes(type)) {
      this.params = new DeviceParamLirisV3();
      this.params = data.params;
    }
    // liris v3 420
    if (type === DeviceTypes.Liris420V3) {
      this.params = new DeviceParamLiris420();
      this.params = data.params;
    }

    // gateway V3
    {
      if (type === DeviceTypes.GatewayV3) {
        this.params = new DeviceParamGatewayV3();
        this.params = data.params;
      }
    }
    // dau_v5
    if (type === DeviceTypes.DauV5) {
      this.params = new DeviceParamDauV5();
      this.params = data.params;
    }
    // v-sensor
    if (type === DeviceTypes.VSensor) {
      // if the sensor has not been affected to any location, then there is no params
      this.params = data.project_device_location ? data.params : null;
    }
    // wavesoft
    if (type >= 1000) {
      this.params = new DeviceParamWavesoft();
      this.params.sold = data.params.sold;
    }
  }

}
